// extracted by mini-css-extract-plugin
export default {"color0":"#f5e6c8","color1":"#2b2b2b","color2":"#f66e0d","color3":"#313131","color4":"#f5e6c8"};